//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError } from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken
} from 'axios';

export class TenantsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get a list of all tenants.
   */
  getList(cancelToken?: CancelToken | undefined): Promise<TenantDto[]> {
    let url_ = this.baseUrl + '/api/tenants';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetList(_response);
      });
  }

  protected processGetList(response: AxiosResponse): Promise<TenantDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(TenantDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<TenantDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a new tenant.
   */
  create(
    request: CreateTenantRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/tenants';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get tenant details.
   */
  get(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<TenantDto> {
    let url_ = this.baseUrl + '/api/tenants/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<TenantDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TenantDto.fromJS(resultData200);
      return Promise.resolve<TenantDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Activate a tenant.
   */
  activate(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/tenants/{id}/activate';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processActivate(_response);
      });
  }

  protected processActivate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Deactivate a tenant.
   */
  deactivate(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/tenants/{id}/deactivate';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'POST',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeactivate(_response);
      });
  }

  protected processDeactivate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Upgrade a tenant's subscription.
   */
  upgradeSubscription(
    id: string | null,
    request: UpgradeSubscriptionRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/tenants/{id}/upgrade';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpgradeSubscription(_response);
      });
  }

  protected processUpgradeSubscription(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class RolesClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get a list of all roles.
   */
  getList(cancelToken?: CancelToken | undefined): Promise<RoleDto[]> {
    let url_ = this.baseUrl + '/api/roles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetList(_response);
      });
  }

  protected processGetList(response: AxiosResponse): Promise<RoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(RoleDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<RoleDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create or update a role.
   */
  registerRole(
    request: CreateOrUpdateRoleRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRegisterRole(_response);
      });
  }

  protected processRegisterRole(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get role details.
   */
  getById(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<RoleDto> {
    let url_ = this.baseUrl + '/api/roles/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetById(_response);
      });
  }

  protected processGetById(response: AxiosResponse): Promise<RoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RoleDto.fromJS(resultData200);
      return Promise.resolve<RoleDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a role.
   */
  delete(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/roles/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get role details with its permissions.
   */
  getByIdWithPermissions(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<RoleDto> {
    let url_ = this.baseUrl + '/api/roles/{id}/permissions';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetByIdWithPermissions(_response);
      });
  }

  protected processGetByIdWithPermissions(
    response: AxiosResponse
  ): Promise<RoleDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = RoleDto.fromJS(resultData200);
      return Promise.resolve<RoleDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a role's permissions.
   */
  updatePermissions(
    id: string | null,
    request: UpdateRolePermissionsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/roles/{id}/permissions';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdatePermissions(_response);
      });
  }

  protected processUpdatePermissions(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class TokensClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Request an access token using credentials.
   * @param tenant Input your tenant Id to access this API
   */
  getToken(
    tenant: string,
    request: TokenRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<TokenResponse> {
    let url_ = this.baseUrl + '/api/tokens';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetToken(_response);
      });
  }

  protected processGetToken(response: AxiosResponse): Promise<TokenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TokenResponse.fromJS(resultData200);
      return Promise.resolve<TokenResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Request an access token using a refresh token.
   * @param tenant Input your tenant Id to access this API
   */
  refresh(
    tenant: string,
    request: RefreshTokenRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<TokenResponse> {
    let url_ = this.baseUrl + '/api/tokens/refresh';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processRefresh(_response);
      });
  }

  protected processRefresh(response: AxiosResponse): Promise<TokenResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = TokenResponse.fromJS(resultData200);
      return Promise.resolve<TokenResponse>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class UsersClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get list of all users.
   */
  getList(cancelToken?: CancelToken | undefined): Promise<UserDetailsDto[]> {
    let url_ = this.baseUrl + '/api/users';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetList(_response);
      });
  }

  protected processGetList(response: AxiosResponse): Promise<UserDetailsDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UserDetailsDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UserDetailsDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Creates a new user.
   */
  create(
    request: CreateUserRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get a user's details.
   */
  getById(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<UserDetailsDto> {
    let url_ = this.baseUrl + '/api/users/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetById(_response);
      });
  }

  protected processGetById(response: AxiosResponse): Promise<UserDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDetailsDto.fromJS(resultData200);
      return Promise.resolve<UserDetailsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get a user's roles.
   */
  getRoles(
    id: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<UserRoleDto[]> {
    let url_ = this.baseUrl + '/api/users/{id}/roles';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetRoles(_response);
      });
  }

  protected processGetRoles(response: AxiosResponse): Promise<UserRoleDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(UserRoleDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<UserRoleDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a user's assigned roles.
   */
  assignRoles(
    id: string | null,
    request: UserRolesRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/{id}/roles';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processAssignRoles(_response);
      });
  }

  protected processAssignRoles(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Anonymous user creates a user.
   * @param tenant Input your tenant Id to access this API
   */
  selfRegister(
    tenant: string,
    request: CreateUserRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/self-register';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSelfRegister(_response);
      });
  }

  protected processSelfRegister(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Toggle a user's active status.
   */
  toggleStatus(
    id: string | null,
    request: ToggleUserStatusRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/users/{id}/toggle-status';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processToggleStatus(_response);
      });
  }

  protected processToggleStatus(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      // const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Confirm email address for a user.
   * @param tenant (optional)
   * @param userId (optional)
   * @param code (optional)
   */
  confirmEmail(
    tenant: string | null | undefined,
    userId: string | null | undefined,
    code: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/confirm-email?';
    if (tenant !== undefined && tenant !== null)
      url_ += 'tenant=' + encodeURIComponent('' + tenant) + '&';
    if (userId !== undefined && userId !== null)
      url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    if (code !== undefined && code !== null)
      url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processConfirmEmail(_response);
      });
  }

  protected processConfirmEmail(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Confirm phone number for a user.
   * @param userId (optional)
   * @param code (optional)
   */
  confirmPhoneNumber(
    userId: string | null | undefined,
    code: string | null | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/confirm-phone-number?';
    if (userId !== undefined && userId !== null)
      url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    if (code !== undefined && code !== null)
      url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processConfirmPhoneNumber(_response);
      });
  }

  protected processConfirmPhoneNumber(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Request a pasword reset email for a user.
   * @param tenant Input your tenant Id to access this API
   */
  forgotPassword(
    tenant: string,
    request: ForgotPasswordRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/forgot-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        tenant: tenant !== undefined && tenant !== null ? '' + tenant : '',
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processForgotPassword(_response);
      });
  }

  protected processForgotPassword(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Reset a user's password.
   */
  resetPassword(
    request: ResetPasswordRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/users/reset-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processResetPassword(_response);
      });
  }

  protected processResetPassword(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class PersonalClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get profile details of currently logged in user.
   */
  getProfile(cancelToken?: CancelToken | undefined): Promise<UserDetailsDto> {
    let url_ = this.baseUrl + '/api/personal/profile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetProfile(_response);
      });
  }

  protected processGetProfile(
    response: AxiosResponse
  ): Promise<UserDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UserDetailsDto.fromJS(resultData200);
      return Promise.resolve<UserDetailsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update profile details of currently logged in user.
   */
  updateProfile(
    request: UpdateUserRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/personal/profile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdateProfile(_response);
      });
  }

  protected processUpdateProfile(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      // const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Change password of currently logged in user.
   */
  changePassword(
    model: ChangePasswordRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<void> {
    let url_ = this.baseUrl + '/api/personal/change-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(model);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processChangePassword(_response);
      });
  }

  protected processChangePassword(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      // const _responseText = response.data;
      return Promise.resolve<void>(null as any);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get permissions of currently logged in user.
   */
  getPermissions(cancelToken?: CancelToken | undefined): Promise<string[]> {
    let url_ = this.baseUrl + '/api/personal/permissions';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPermissions(_response);
      });
  }

  protected processGetPermissions(response: AxiosResponse): Promise<string[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(item);
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<string[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get audit logs of currently logged in user.
   */
  getLogs(cancelToken?: CancelToken | undefined): Promise<AuditDto[]> {
    let url_ = this.baseUrl + '/api/personal/logs';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetLogs(_response);
      });
  }

  protected processGetLogs(response: AxiosResponse): Promise<AuditDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200) result200!.push(AuditDto.fromJS(item));
      } else {
        result200 = <any>null;
      }
      return Promise.resolve<AuditDto[]>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class DashboardClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Get statistics for the dashboard.
   */
  get(cancelToken?: CancelToken | undefined): Promise<StatsDto> {
    let url_ = this.baseUrl + '/api/v1/dashboard';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<StatsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = StatsDto.fromJS(resultData200);
      return Promise.resolve<StatsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class CmsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Create a new product.
   */
  create(
    command: CmsCreateSubpageCommand,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/cms';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(command);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get menu by name
   */
  getMenuByName(
    menuName: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<MenuDto> {
    let url_ = this.baseUrl + '/api/v1/cms/menu/{menuName}';
    if (menuName === undefined || menuName === null)
      throw new Error("The parameter 'menuName' must be defined.");
    url_ = url_.replace('{menuName}', encodeURIComponent('' + menuName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetMenuByName(_response);
      });
  }

  protected processGetMenuByName(response: AxiosResponse): Promise<MenuDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = MenuDto.fromJS(resultData200);
      return Promise.resolve<MenuDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get menu by name
   */
  getPageByFriendlyUrl(
    friendlyUrl: string | null,
    cancelToken?: CancelToken | undefined
  ): Promise<PageDto> {
    let url_ = this.baseUrl + '/api/v1/cms/page/{friendlyUrl}';
    if (friendlyUrl === undefined || friendlyUrl === null)
      throw new Error("The parameter 'friendlyUrl' must be defined.");
    url_ = url_.replace('{friendlyUrl}', encodeURIComponent('' + friendlyUrl));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetPageByFriendlyUrl(_response);
      });
  }

  protected processGetPageByFriendlyUrl(
    response: AxiosResponse
  ): Promise<PageDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PageDto.fromJS(resultData200);
      return Promise.resolve<PageDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class BrandsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search brands using available filters.
   */
  search(
    request: SearchBrandsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfBrandDto> {
    let url_ = this.baseUrl + '/api/v1/brands/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PaginationResponseOfBrandDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfBrandDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfBrandDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get brand details.
   */
  get(id: string, cancelToken?: CancelToken | undefined): Promise<BrandDto> {
    let url_ = this.baseUrl + '/api/v1/brands/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<BrandDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = BrandDto.fromJS(resultData200);
      return Promise.resolve<BrandDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a brand.
   */
  update(
    id: string,
    request: UpdateBrandRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/brands/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a brand.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/brands/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a new brand.
   */
  create(
    request: CreateBrandRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/brands';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Generate a number of random brands.
   */
  generateRandom(
    request: GenerateRandomBrandRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/brands/generate-random';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGenerateRandom(_response);
      });
  }

  protected processGenerateRandom(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete the brands generated with the generate-random call.
   */
  deleteRandom(cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/brands/delete-random';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDeleteRandom(_response);
      });
  }

  protected processDeleteRandom(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }
}

export class ProductsClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();

    this.baseUrl =
      baseUrl !== undefined && baseUrl !== null
        ? baseUrl
        : 'https://localhost:5001';
  }

  /**
   * Search products using available filters.
   */
  search(
    request: SearchProductsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<PaginationResponseOfProductDto> {
    let url_ = this.baseUrl + '/api/v1/products/search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processSearch(_response);
      });
  }

  protected processSearch(
    response: AxiosResponse
  ): Promise<PaginationResponseOfProductDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = PaginationResponseOfProductDto.fromJS(resultData200);
      return Promise.resolve<PaginationResponseOfProductDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get product details.
   */
  get(
    id: string,
    cancelToken?: CancelToken | undefined
  ): Promise<ProductDetailsDto> {
    let url_ = this.baseUrl + '/api/v1/products/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGet(_response);
      });
  }

  protected processGet(response: AxiosResponse): Promise<ProductDetailsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProductDetailsDto.fromJS(resultData200);
      return Promise.resolve<ProductDetailsDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Update a product.
   */
  update(
    id: string,
    request: UpdateProductRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/products/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'PUT',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processUpdate(_response);
      });
  }

  protected processUpdate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Delete a product.
   */
  delete(id: string, cancelToken?: CancelToken | undefined): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/products/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'DELETE',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processDelete(_response);
      });
  }

  protected processDelete(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Get product details via dapper.
   * @param id (optional)
   */
  getDapper(
    id: string | undefined,
    cancelToken?: CancelToken | undefined
  ): Promise<ProductDto> {
    let url_ = this.baseUrl + '/api/v1/products/dapper?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined)
      url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: AxiosRequestConfig = {
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processGetDapper(_response);
      });
  }

  protected processGetDapper(response: AxiosResponse): Promise<ProductDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ProductDto.fromJS(resultData200);
      return Promise.resolve<ProductDto>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Create a new product.
   */
  create(
    request: CreateProductRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<string> {
    let url_ = this.baseUrl + '/api/v1/products';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(request);

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processCreate(_response);
      });
  }

  protected processCreate(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;

      return Promise.resolve<string>(result200);
    } else if (status === 400) {
      const _responseText = response.data;
      let result400: any = null;
      let resultData400 = _responseText;
      result400 = HttpValidationProblemDetails.fromJS(resultData400);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        result400
      );
    } else {
      const _responseText = response.data;
      let resultdefault: any = null;
      let resultDatadefault = _responseText;
      resultdefault = ErrorResult.fromJS(resultDatadefault);
      return throwException(
        'A server side error occurred.',
        status,
        _responseText,
        _headers,
        resultdefault
      );
    }
  }

  /**
   * Export a products.
   */
  export(
    filter: ExportProductsRequest,
    cancelToken?: CancelToken | undefined
  ): Promise<FileResponse> {
    let url_ = this.baseUrl + '/api/v1/products/export';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(filter);

    let options_: AxiosRequestConfig = {
      data: content_,
      responseType: 'blob',
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/octet-stream'
      },
      cancelToken
    };

    return this.instance
      .request(options_)
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response;
        } else {
          throw _error;
        }
      })
      .then((_response: AxiosResponse) => {
        return this.processExport(_response);
      });
  }

  protected processExport(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers['content-disposition']
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: new Blob([response.data], {
          type: response.headers['content-type']
        }),
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        'An unexpected server error occurred.',
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(null as any);
  }
}

export class TenantDto implements ITenantDto {
  id?: string;
  name?: string;
  connectionString?: string | undefined;
  adminEmail?: string;
  isActive?: boolean;
  validUpto?: Date;
  issuer?: string | undefined;

  constructor(data?: ITenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.connectionString = _data['connectionString'];
      this.adminEmail = _data['adminEmail'];
      this.isActive = _data['isActive'];
      this.validUpto = _data['validUpto']
        ? new Date(_data['validUpto'].toString())
        : <any>undefined;
      this.issuer = _data['issuer'];
    }
  }

  static fromJS(data: any): TenantDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['connectionString'] = this.connectionString;
    data['adminEmail'] = this.adminEmail;
    data['isActive'] = this.isActive;
    data['validUpto'] = this.validUpto
      ? this.validUpto.toISOString()
      : <any>undefined;
    data['issuer'] = this.issuer;
    return data;
  }
}

export interface ITenantDto {
  id?: string;
  name?: string;
  connectionString?: string | undefined;
  adminEmail?: string;
  isActive?: boolean;
  validUpto?: Date;
  issuer?: string | undefined;
}

export class ProblemDetails implements IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;

  constructor(data?: IProblemDetails) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.title = _data['title'];
      this.status = _data['status'];
      this.detail = _data['detail'];
      this.instance = _data['instance'];
    }
  }

  static fromJS(data: any): ProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetails();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['title'] = this.title;
    data['status'] = this.status;
    data['detail'] = this.detail;
    data['instance'] = this.instance;
    return data;
  }
}

export interface IProblemDetails {
  type?: string | undefined;
  title?: string | undefined;
  status?: number | undefined;
  detail?: string | undefined;
  instance?: string | undefined;
}

export class HttpValidationProblemDetails
  extends ProblemDetails
  implements IHttpValidationProblemDetails
{
  errors?: { [key: string]: string[] };

  constructor(data?: IHttpValidationProblemDetails) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (_data['errors']) {
        this.errors = {} as any;
        for (let key in _data['errors']) {
          if (_data['errors'].hasOwnProperty(key))
            (<any>this.errors)![key] =
              _data['errors'][key] !== undefined ? _data['errors'][key] : [];
        }
      }
    }
  }

  static override fromJS(data: any): HttpValidationProblemDetails {
    data = typeof data === 'object' ? data : {};
    let result = new HttpValidationProblemDetails();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.errors) {
      data['errors'] = {};
      for (let key in this.errors) {
        if (this.errors.hasOwnProperty(key))
          (<any>data['errors'])[key] = (<any>this.errors)[key];
      }
    }
    super.toJSON(data);
    return data;
  }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
  errors?: { [key: string]: string[] };
}

export class ErrorResult implements IErrorResult {
  messages?: string[] | undefined;
  source?: string | undefined;
  exception?: string | undefined;
  errorId?: string | undefined;
  supportMessage?: string | undefined;
  statusCode?: number;

  constructor(data?: IErrorResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['messages'])) {
        this.messages = [] as any;
        for (let item of _data['messages']) this.messages!.push(item);
      }
      this.source = _data['source'];
      this.exception = _data['exception'];
      this.errorId = _data['errorId'];
      this.supportMessage = _data['supportMessage'];
      this.statusCode = _data['statusCode'];
    }
  }

  static fromJS(data: any): ErrorResult {
    data = typeof data === 'object' ? data : {};
    let result = new ErrorResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.messages)) {
      data['messages'] = [];
      for (let item of this.messages) data['messages'].push(item);
    }
    data['source'] = this.source;
    data['exception'] = this.exception;
    data['errorId'] = this.errorId;
    data['supportMessage'] = this.supportMessage;
    data['statusCode'] = this.statusCode;
    return data;
  }
}

export interface IErrorResult {
  messages?: string[] | undefined;
  source?: string | undefined;
  exception?: string | undefined;
  errorId?: string | undefined;
  supportMessage?: string | undefined;
  statusCode?: number;
}

export class CreateTenantRequest implements ICreateTenantRequest {
  id!: string;
  name!: string;
  connectionString?: string | undefined;
  adminEmail!: string;
  issuer?: string | undefined;

  constructor(data?: ICreateTenantRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.connectionString = _data['connectionString'];
      this.adminEmail = _data['adminEmail'];
      this.issuer = _data['issuer'];
    }
  }

  static fromJS(data: any): CreateTenantRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateTenantRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['connectionString'] = this.connectionString;
    data['adminEmail'] = this.adminEmail;
    data['issuer'] = this.issuer;
    return data;
  }
}

export interface ICreateTenantRequest {
  id: string;
  name: string;
  connectionString?: string | undefined;
  adminEmail: string;
  issuer?: string | undefined;
}

export class UpgradeSubscriptionRequest implements IUpgradeSubscriptionRequest {
  tenantId!: string;
  extendedExpiryDate?: Date;

  constructor(data?: IUpgradeSubscriptionRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tenantId = _data['tenantId'];
      this.extendedExpiryDate = _data['extendedExpiryDate']
        ? new Date(_data['extendedExpiryDate'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): UpgradeSubscriptionRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpgradeSubscriptionRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tenantId'] = this.tenantId;
    data['extendedExpiryDate'] = this.extendedExpiryDate
      ? this.extendedExpiryDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IUpgradeSubscriptionRequest {
  tenantId: string;
  extendedExpiryDate?: Date;
}

export class RoleDto implements IRoleDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  permissions?: string[] | undefined;

  constructor(data?: IRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): RoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new RoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    return data;
  }
}

export interface IRoleDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  permissions?: string[] | undefined;
}

export class UpdateRolePermissionsRequest
  implements IUpdateRolePermissionsRequest
{
  roleId!: string;
  permissions!: string[];

  constructor(data?: IUpdateRolePermissionsRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.permissions = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId'];
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions']) this.permissions!.push(item);
      }
    }
  }

  static fromJS(data: any): UpdateRolePermissionsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateRolePermissionsRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['roleId'] = this.roleId;
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item);
    }
    return data;
  }
}

export interface IUpdateRolePermissionsRequest {
  roleId: string;
  permissions: string[];
}

export class CreateOrUpdateRoleRequest implements ICreateOrUpdateRoleRequest {
  id?: string | undefined;
  name!: string;
  description?: string | undefined;

  constructor(data?: ICreateOrUpdateRoleRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): CreateOrUpdateRoleRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrUpdateRoleRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }
}

export interface ICreateOrUpdateRoleRequest {
  id?: string | undefined;
  name: string;
  description?: string | undefined;
}

export class TokenResponse implements ITokenResponse {
  token?: string;
  refreshToken?: string;
  refreshTokenExpiryTime?: Date;

  constructor(data?: ITokenResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data['token'];
      this.refreshToken = _data['refreshToken'];
      this.refreshTokenExpiryTime = _data['refreshTokenExpiryTime']
        ? new Date(_data['refreshTokenExpiryTime'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): TokenResponse {
    data = typeof data === 'object' ? data : {};
    let result = new TokenResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['token'] = this.token;
    data['refreshToken'] = this.refreshToken;
    data['refreshTokenExpiryTime'] = this.refreshTokenExpiryTime
      ? this.refreshTokenExpiryTime.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface ITokenResponse {
  token?: string;
  refreshToken?: string;
  refreshTokenExpiryTime?: Date;
}

export class TokenRequest implements ITokenRequest {
  email!: string;
  password!: string;

  constructor(data?: ITokenRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email'];
      this.password = _data['password'];
    }
  }

  static fromJS(data: any): TokenRequest {
    data = typeof data === 'object' ? data : {};
    let result = new TokenRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    data['password'] = this.password;
    return data;
  }
}

export interface ITokenRequest {
  email: string;
  password: string;
}

export class RefreshTokenRequest implements IRefreshTokenRequest {
  token?: string;
  refreshToken?: string;

  constructor(data?: IRefreshTokenRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.token = _data['token'];
      this.refreshToken = _data['refreshToken'];
    }
  }

  static fromJS(data: any): RefreshTokenRequest {
    data = typeof data === 'object' ? data : {};
    let result = new RefreshTokenRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['token'] = this.token;
    data['refreshToken'] = this.refreshToken;
    return data;
  }
}

export interface IRefreshTokenRequest {
  token?: string;
  refreshToken?: string;
}

export class UserDetailsDto implements IUserDetailsDto {
  id?: string;
  userName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  phoneNumber?: string | undefined;
  imageUrl?: string | undefined;

  constructor(data?: IUserDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.email = _data['email'];
      this.isActive = _data['isActive'];
      this.emailConfirmed = _data['emailConfirmed'];
      this.phoneNumber = _data['phoneNumber'];
      this.imageUrl = _data['imageUrl'];
    }
  }

  static fromJS(data: any): UserDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['email'] = this.email;
    data['isActive'] = this.isActive;
    data['emailConfirmed'] = this.emailConfirmed;
    data['phoneNumber'] = this.phoneNumber;
    data['imageUrl'] = this.imageUrl;
    return data;
  }
}

export interface IUserDetailsDto {
  id?: string;
  userName?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  isActive?: boolean;
  emailConfirmed?: boolean;
  phoneNumber?: string | undefined;
  imageUrl?: string | undefined;
}

export class UserRoleDto implements IUserRoleDto {
  roleId?: string | undefined;
  roleName?: string | undefined;
  description?: string | undefined;
  enabled?: boolean;

  constructor(data?: IUserRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.roleId = _data['roleId'];
      this.roleName = _data['roleName'];
      this.description = _data['description'];
      this.enabled = _data['enabled'];
    }
  }

  static fromJS(data: any): UserRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new UserRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['roleId'] = this.roleId;
    data['roleName'] = this.roleName;
    data['description'] = this.description;
    data['enabled'] = this.enabled;
    return data;
  }
}

export interface IUserRoleDto {
  roleId?: string | undefined;
  roleName?: string | undefined;
  description?: string | undefined;
  enabled?: boolean;
}

export class UserRolesRequest implements IUserRolesRequest {
  userRoles?: UserRoleDto[];

  constructor(data?: IUserRolesRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['userRoles'])) {
        this.userRoles = [] as any;
        for (let item of _data['userRoles'])
          this.userRoles!.push(UserRoleDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UserRolesRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UserRolesRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.userRoles)) {
      data['userRoles'] = [];
      for (let item of this.userRoles) data['userRoles'].push(item.toJSON());
    }
    return data;
  }
}

export interface IUserRolesRequest {
  userRoles?: UserRoleDto[];
}

export class CreateUserRequest implements ICreateUserRequest {
  firstName!: string;
  lastName!: string;
  email!: string;
  userName!: string;
  password!: string;
  confirmPassword!: string;
  phoneNumber?: string | undefined;

  constructor(data?: ICreateUserRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.email = _data['email'];
      this.userName = _data['userName'];
      this.password = _data['password'];
      this.confirmPassword = _data['confirmPassword'];
      this.phoneNumber = _data['phoneNumber'];
    }
  }

  static fromJS(data: any): CreateUserRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateUserRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['email'] = this.email;
    data['userName'] = this.userName;
    data['password'] = this.password;
    data['confirmPassword'] = this.confirmPassword;
    data['phoneNumber'] = this.phoneNumber;
    return data;
  }
}

export interface ICreateUserRequest {
  firstName: string;
  lastName: string;
  email: string;
  userName: string;
  password: string;
  confirmPassword: string;
  phoneNumber?: string | undefined;
}

export class ToggleUserStatusRequest implements IToggleUserStatusRequest {
  activateUser?: boolean;
  userId?: string | undefined;

  constructor(data?: IToggleUserStatusRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.activateUser = _data['activateUser'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): ToggleUserStatusRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ToggleUserStatusRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['activateUser'] = this.activateUser;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IToggleUserStatusRequest {
  activateUser?: boolean;
  userId?: string | undefined;
}

export class ForgotPasswordRequest implements IForgotPasswordRequest {
  email!: string;

  constructor(data?: IForgotPasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email'];
    }
  }

  static fromJS(data: any): ForgotPasswordRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ForgotPasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    return data;
  }
}

export interface IForgotPasswordRequest {
  email: string;
}

export class ResetPasswordRequest implements IResetPasswordRequest {
  email?: string | undefined;
  password?: string | undefined;
  token?: string | undefined;

  constructor(data?: IResetPasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email'];
      this.password = _data['password'];
      this.token = _data['token'];
    }
  }

  static fromJS(data: any): ResetPasswordRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    data['password'] = this.password;
    data['token'] = this.token;
    return data;
  }
}

export interface IResetPasswordRequest {
  email?: string | undefined;
  password?: string | undefined;
  token?: string | undefined;
}

export class UpdateUserRequest implements IUpdateUserRequest {
  id!: string;
  firstName!: string;
  lastName!: string;
  phoneNumber?: string | undefined;
  email!: string;
  image?: FileUploadRequest | undefined;
  deleteCurrentImage?: boolean;

  constructor(data?: IUpdateUserRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.firstName = _data['firstName'];
      this.lastName = _data['lastName'];
      this.phoneNumber = _data['phoneNumber'];
      this.email = _data['email'];
      this.image = _data['image']
        ? FileUploadRequest.fromJS(_data['image'])
        : <any>undefined;
      this.deleteCurrentImage = _data['deleteCurrentImage'];
    }
  }

  static fromJS(data: any): UpdateUserRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateUserRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['firstName'] = this.firstName;
    data['lastName'] = this.lastName;
    data['phoneNumber'] = this.phoneNumber;
    data['email'] = this.email;
    data['image'] = this.image ? this.image.toJSON() : <any>undefined;
    data['deleteCurrentImage'] = this.deleteCurrentImage;
    return data;
  }
}

export interface IUpdateUserRequest {
  id: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string | undefined;
  email: string;
  image?: FileUploadRequest | undefined;
  deleteCurrentImage?: boolean;
}

export class FileUploadRequest implements IFileUploadRequest {
  name!: string;
  extension!: string;
  data!: string;

  constructor(data?: IFileUploadRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.extension = _data['extension'];
      this.data = _data['data'];
    }
  }

  static fromJS(data: any): FileUploadRequest {
    data = typeof data === 'object' ? data : {};
    let result = new FileUploadRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['extension'] = this.extension;
    data['data'] = this.data;
    return data;
  }
}

export interface IFileUploadRequest {
  name: string;
  extension: string;
  data: string;
}

export class ChangePasswordRequest implements IChangePasswordRequest {
  password!: string;
  newPassword!: string;
  confirmNewPassword?: string;

  constructor(data?: IChangePasswordRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.password = _data['password'];
      this.newPassword = _data['newPassword'];
      this.confirmNewPassword = _data['confirmNewPassword'];
    }
  }

  static fromJS(data: any): ChangePasswordRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ChangePasswordRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['password'] = this.password;
    data['newPassword'] = this.newPassword;
    data['confirmNewPassword'] = this.confirmNewPassword;
    return data;
  }
}

export interface IChangePasswordRequest {
  password: string;
  newPassword: string;
  confirmNewPassword?: string;
}

export class AuditDto implements IAuditDto {
  id?: string;
  userId?: string;
  type?: string | undefined;
  tableName?: string | undefined;
  dateTime?: Date;
  oldValues?: string | undefined;
  newValues?: string | undefined;
  affectedColumns?: string | undefined;
  primaryKey?: string | undefined;

  constructor(data?: IAuditDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userId = _data['userId'];
      this.type = _data['type'];
      this.tableName = _data['tableName'];
      this.dateTime = _data['dateTime']
        ? new Date(_data['dateTime'].toString())
        : <any>undefined;
      this.oldValues = _data['oldValues'];
      this.newValues = _data['newValues'];
      this.affectedColumns = _data['affectedColumns'];
      this.primaryKey = _data['primaryKey'];
    }
  }

  static fromJS(data: any): AuditDto {
    data = typeof data === 'object' ? data : {};
    let result = new AuditDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userId'] = this.userId;
    data['type'] = this.type;
    data['tableName'] = this.tableName;
    data['dateTime'] = this.dateTime
      ? this.dateTime.toISOString()
      : <any>undefined;
    data['oldValues'] = this.oldValues;
    data['newValues'] = this.newValues;
    data['affectedColumns'] = this.affectedColumns;
    data['primaryKey'] = this.primaryKey;
    return data;
  }
}

export interface IAuditDto {
  id?: string;
  userId?: string;
  type?: string | undefined;
  tableName?: string | undefined;
  dateTime?: Date;
  oldValues?: string | undefined;
  newValues?: string | undefined;
  affectedColumns?: string | undefined;
  primaryKey?: string | undefined;
}

export class StatsDto implements IStatsDto {
  productCount?: number;
  brandCount?: number;
  userCount?: number;
  roleCount?: number;
  dataEnterBarChart?: ChartSeries[];
  productByBrandTypePieChart?: { [key: string]: number } | undefined;

  constructor(data?: IStatsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.productCount = _data['productCount'];
      this.brandCount = _data['brandCount'];
      this.userCount = _data['userCount'];
      this.roleCount = _data['roleCount'];
      if (Array.isArray(_data['dataEnterBarChart'])) {
        this.dataEnterBarChart = [] as any;
        for (let item of _data['dataEnterBarChart'])
          this.dataEnterBarChart!.push(ChartSeries.fromJS(item));
      }
      if (_data['productByBrandTypePieChart']) {
        this.productByBrandTypePieChart = {} as any;
        for (let key in _data['productByBrandTypePieChart']) {
          if (_data['productByBrandTypePieChart'].hasOwnProperty(key))
            (<any>this.productByBrandTypePieChart)![key] =
              _data['productByBrandTypePieChart'][key];
        }
      }
    }
  }

  static fromJS(data: any): StatsDto {
    data = typeof data === 'object' ? data : {};
    let result = new StatsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['productCount'] = this.productCount;
    data['brandCount'] = this.brandCount;
    data['userCount'] = this.userCount;
    data['roleCount'] = this.roleCount;
    if (Array.isArray(this.dataEnterBarChart)) {
      data['dataEnterBarChart'] = [];
      for (let item of this.dataEnterBarChart)
        data['dataEnterBarChart'].push(item.toJSON());
    }
    if (this.productByBrandTypePieChart) {
      data['productByBrandTypePieChart'] = {};
      for (let key in this.productByBrandTypePieChart) {
        if (this.productByBrandTypePieChart.hasOwnProperty(key))
          (<any>data['productByBrandTypePieChart'])[key] = (<any>(
            this.productByBrandTypePieChart
          ))[key];
      }
    }
    return data;
  }
}

export interface IStatsDto {
  productCount?: number;
  brandCount?: number;
  userCount?: number;
  roleCount?: number;
  dataEnterBarChart?: ChartSeries[];
  productByBrandTypePieChart?: { [key: string]: number } | undefined;
}

export class ChartSeries implements IChartSeries {
  name?: string | undefined;
  data?: number[] | undefined;

  constructor(data?: IChartSeries) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(item);
      }
    }
  }

  static fromJS(data: any): ChartSeries {
    data = typeof data === 'object' ? data : {};
    let result = new ChartSeries();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item);
    }
    return data;
  }
}

export interface IChartSeries {
  name?: string | undefined;
  data?: number[] | undefined;
}

export class CmsCreateSubpageCommand implements ICmsCreateSubpageCommand {
  name?: string;
  description?: string | undefined;
  rate?: number;
  brandId?: string;
  image?: FileUploadRequest | undefined;

  constructor(data?: ICmsCreateSubpageCommand) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.description = _data['description'];
      this.rate = _data['rate'];
      this.brandId = _data['brandId'];
      this.image = _data['image']
        ? FileUploadRequest.fromJS(_data['image'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CmsCreateSubpageCommand {
    data = typeof data === 'object' ? data : {};
    let result = new CmsCreateSubpageCommand();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['rate'] = this.rate;
    data['brandId'] = this.brandId;
    data['image'] = this.image ? this.image.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICmsCreateSubpageCommand {
  name?: string;
  description?: string | undefined;
  rate?: number;
  brandId?: string;
  image?: FileUploadRequest | undefined;
}

export class MenuDto implements IMenuDto {
  id?: string;
  name?: string;
  items?: MenuItemDto[];

  constructor(data?: IMenuDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(MenuItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MenuDto {
    data = typeof data === 'object' ? data : {};
    let result = new MenuDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IMenuDto {
  id?: string;
  name?: string;
  items?: MenuItemDto[];
}

export class MenuItemDto implements IMenuItemDto {
  id?: string;
  menuId?: string;
  pageId?: string | undefined;
  customLabel?: string | undefined;
  customUrl?: string | undefined;
  order?: number;
  parentItemId?: string | undefined;
  children?: MenuItemDto[];

  constructor(data?: IMenuItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.menuId = _data['menuId'];
      this.pageId = _data['pageId'];
      this.customLabel = _data['customLabel'];
      this.customUrl = _data['customUrl'];
      this.order = _data['order'];
      this.parentItemId = _data['parentItemId'];
      if (Array.isArray(_data['children'])) {
        this.children = [] as any;
        for (let item of _data['children'])
          this.children!.push(MenuItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MenuItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new MenuItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['menuId'] = this.menuId;
    data['pageId'] = this.pageId;
    data['customLabel'] = this.customLabel;
    data['customUrl'] = this.customUrl;
    data['order'] = this.order;
    data['parentItemId'] = this.parentItemId;
    if (Array.isArray(this.children)) {
      data['children'] = [];
      for (let item of this.children) data['children'].push(item.toJSON());
    }
    return data;
  }
}

export interface IMenuItemDto {
  id?: string;
  menuId?: string;
  pageId?: string | undefined;
  customLabel?: string | undefined;
  customUrl?: string | undefined;
  order?: number;
  parentItemId?: string | undefined;
  children?: MenuItemDto[];
}

export class PageDto implements IPageDto {
  id?: string;
  title?: string;
  slug?: string;
  isPublished?: boolean;
  currentRevisionId?: string | undefined;
  currentRevision?: PageRevisionDto | undefined;
  revisions?: PageRevisionDto[];
  seoMeta?: PageSeoMetaDto | undefined;

  constructor(data?: IPageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.title = _data['title'];
      this.slug = _data['slug'];
      this.isPublished = _data['isPublished'];
      this.currentRevisionId = _data['currentRevisionId'];
      this.currentRevision = _data['currentRevision']
        ? PageRevisionDto.fromJS(_data['currentRevision'])
        : <any>undefined;
      if (Array.isArray(_data['revisions'])) {
        this.revisions = [] as any;
        for (let item of _data['revisions'])
          this.revisions!.push(PageRevisionDto.fromJS(item));
      }
      this.seoMeta = _data['seoMeta']
        ? PageSeoMetaDto.fromJS(_data['seoMeta'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): PageDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['title'] = this.title;
    data['slug'] = this.slug;
    data['isPublished'] = this.isPublished;
    data['currentRevisionId'] = this.currentRevisionId;
    data['currentRevision'] = this.currentRevision
      ? this.currentRevision.toJSON()
      : <any>undefined;
    if (Array.isArray(this.revisions)) {
      data['revisions'] = [];
      for (let item of this.revisions) data['revisions'].push(item.toJSON());
    }
    data['seoMeta'] = this.seoMeta ? this.seoMeta.toJSON() : <any>undefined;
    return data;
  }
}

export interface IPageDto {
  id?: string;
  title?: string;
  slug?: string;
  isPublished?: boolean;
  currentRevisionId?: string | undefined;
  currentRevision?: PageRevisionDto | undefined;
  revisions?: PageRevisionDto[];
  seoMeta?: PageSeoMetaDto | undefined;
}

export class PageRevisionDto implements IPageRevisionDto {
  id?: string;
  pageId?: string;
  createdAt?: Date;
  createdBy?: string | undefined;
  layoutJson?: string;
  page?: PageDto;

  constructor(data?: IPageRevisionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.pageId = _data['pageId'];
      this.createdAt = _data['createdAt']
        ? new Date(_data['createdAt'].toString())
        : <any>undefined;
      this.createdBy = _data['createdBy'];
      this.layoutJson = _data['layoutJson'];
      this.page = _data['page']
        ? PageDto.fromJS(_data['page'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): PageRevisionDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageRevisionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['pageId'] = this.pageId;
    data['createdAt'] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined;
    data['createdBy'] = this.createdBy;
    data['layoutJson'] = this.layoutJson;
    data['page'] = this.page ? this.page.toJSON() : <any>undefined;
    return data;
  }
}

export interface IPageRevisionDto {
  id?: string;
  pageId?: string;
  createdAt?: Date;
  createdBy?: string | undefined;
  layoutJson?: string;
  page?: PageDto;
}

export class PageSeoMetaDto implements IPageSeoMetaDto {
  pageId?: string;
  metaTitle?: string | undefined;
  metaDescription?: string | undefined;
  canonicalUrl?: string | undefined;
  page?: PageDto;

  constructor(data?: IPageSeoMetaDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.pageId = _data['pageId'];
      this.metaTitle = _data['metaTitle'];
      this.metaDescription = _data['metaDescription'];
      this.canonicalUrl = _data['canonicalUrl'];
      this.page = _data['page']
        ? PageDto.fromJS(_data['page'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): PageSeoMetaDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageSeoMetaDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['pageId'] = this.pageId;
    data['metaTitle'] = this.metaTitle;
    data['metaDescription'] = this.metaDescription;
    data['canonicalUrl'] = this.canonicalUrl;
    data['page'] = this.page ? this.page.toJSON() : <any>undefined;
    return data;
  }
}

export interface IPageSeoMetaDto {
  pageId?: string;
  metaTitle?: string | undefined;
  metaDescription?: string | undefined;
  canonicalUrl?: string | undefined;
  page?: PageDto;
}

export class PaginationResponseOfBrandDto
  implements IPaginationResponseOfBrandDto
{
  data?: BrandDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfBrandDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data']) this.data!.push(BrandDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfBrandDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfBrandDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfBrandDto {
  data?: BrandDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class BrandDto implements IBrandDto {
  id?: string;
  name?: string;
  description?: string | undefined;

  constructor(data?: IBrandDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): BrandDto {
    data = typeof data === 'object' ? data : {};
    let result = new BrandDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }
}

export interface IBrandDto {
  id?: string;
  name?: string;
  description?: string | undefined;
}

export class BaseFilter implements IBaseFilter {
  /** Column Wise Search is Supported. */
  advancedSearch?: Search | undefined;
  /** Keyword to Search in All the available columns of the Resource. */
  keyword?: string | undefined;

  constructor(data?: IBaseFilter) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.advancedSearch = _data['advancedSearch']
        ? Search.fromJS(_data['advancedSearch'])
        : <any>undefined;
      this.keyword = _data['keyword'];
    }
  }

  static fromJS(data: any): BaseFilter {
    data = typeof data === 'object' ? data : {};
    let result = new BaseFilter();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['advancedSearch'] = this.advancedSearch
      ? this.advancedSearch.toJSON()
      : <any>undefined;
    data['keyword'] = this.keyword;
    return data;
  }
}

export interface IBaseFilter {
  /** Column Wise Search is Supported. */
  advancedSearch?: Search | undefined;
  /** Keyword to Search in All the available columns of the Resource. */
  keyword?: string | undefined;
}

export class PaginationFilter extends BaseFilter implements IPaginationFilter {
  pageNumber?: number;
  pageSize?: number;
  orderBy?: string[] | undefined;

  constructor(data?: IPaginationFilter) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.pageNumber = _data['pageNumber'];
      this.pageSize = _data['pageSize'];
      if (Array.isArray(_data['orderBy'])) {
        this.orderBy = [] as any;
        for (let item of _data['orderBy']) this.orderBy!.push(item);
      }
    }
  }

  static override fromJS(data: any): PaginationFilter {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationFilter();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['pageNumber'] = this.pageNumber;
    data['pageSize'] = this.pageSize;
    if (Array.isArray(this.orderBy)) {
      data['orderBy'] = [];
      for (let item of this.orderBy) data['orderBy'].push(item);
    }
    super.toJSON(data);
    return data;
  }
}

export interface IPaginationFilter extends IBaseFilter {
  pageNumber?: number;
  pageSize?: number;
  orderBy?: string[] | undefined;
}

export class SearchBrandsRequest
  extends PaginationFilter
  implements ISearchBrandsRequest
{
  constructor(data?: ISearchBrandsRequest) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
  }

  static override fromJS(data: any): SearchBrandsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchBrandsRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface ISearchBrandsRequest extends IPaginationFilter {}

export class Search implements ISearch {
  fields?: string[];
  keyword?: string | undefined;

  constructor(data?: ISearch) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['fields'])) {
        this.fields = [] as any;
        for (let item of _data['fields']) this.fields!.push(item);
      }
      this.keyword = _data['keyword'];
    }
  }

  static fromJS(data: any): Search {
    data = typeof data === 'object' ? data : {};
    let result = new Search();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.fields)) {
      data['fields'] = [];
      for (let item of this.fields) data['fields'].push(item);
    }
    data['keyword'] = this.keyword;
    return data;
  }
}

export interface ISearch {
  fields?: string[];
  keyword?: string | undefined;
}

export class CreateBrandRequest implements ICreateBrandRequest {
  name!: string;
  description?: string | undefined;

  constructor(data?: ICreateBrandRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): CreateBrandRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateBrandRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }
}

export interface ICreateBrandRequest {
  name: string;
  description?: string | undefined;
}

export class UpdateBrandRequest implements IUpdateBrandRequest {
  id?: string;
  name!: string;
  description?: string | undefined;

  constructor(data?: IUpdateBrandRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
    }
  }

  static fromJS(data: any): UpdateBrandRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateBrandRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    return data;
  }
}

export interface IUpdateBrandRequest {
  id?: string;
  name: string;
  description?: string | undefined;
}

export class GenerateRandomBrandRequest implements IGenerateRandomBrandRequest {
  nSeed?: number;

  constructor(data?: IGenerateRandomBrandRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.nSeed = _data['nSeed'];
    }
  }

  static fromJS(data: any): GenerateRandomBrandRequest {
    data = typeof data === 'object' ? data : {};
    let result = new GenerateRandomBrandRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['nSeed'] = this.nSeed;
    return data;
  }
}

export interface IGenerateRandomBrandRequest {
  nSeed?: number;
}

export class PaginationResponseOfProductDto
  implements IPaginationResponseOfProductDto
{
  data?: ProductDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;

  constructor(data?: IPaginationResponseOfProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['data'])) {
        this.data = [] as any;
        for (let item of _data['data'])
          this.data!.push(ProductDto.fromJS(item));
      }
      this.currentPage = _data['currentPage'];
      this.totalPages = _data['totalPages'];
      this.totalCount = _data['totalCount'];
      this.pageSize = _data['pageSize'];
      this.hasPreviousPage = _data['hasPreviousPage'];
      this.hasNextPage = _data['hasNextPage'];
    }
  }

  static fromJS(data: any): PaginationResponseOfProductDto {
    data = typeof data === 'object' ? data : {};
    let result = new PaginationResponseOfProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.data)) {
      data['data'] = [];
      for (let item of this.data) data['data'].push(item.toJSON());
    }
    data['currentPage'] = this.currentPage;
    data['totalPages'] = this.totalPages;
    data['totalCount'] = this.totalCount;
    data['pageSize'] = this.pageSize;
    data['hasPreviousPage'] = this.hasPreviousPage;
    data['hasNextPage'] = this.hasNextPage;
    return data;
  }
}

export interface IPaginationResponseOfProductDto {
  data?: ProductDto[];
  currentPage?: number;
  totalPages?: number;
  totalCount?: number;
  pageSize?: number;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export class ProductDto implements IProductDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  rate?: number;
  imagePath?: string | undefined;
  brandId?: string;
  brandName?: string;

  constructor(data?: IProductDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.rate = _data['rate'];
      this.imagePath = _data['imagePath'];
      this.brandId = _data['brandId'];
      this.brandName = _data['brandName'];
    }
  }

  static fromJS(data: any): ProductDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProductDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['rate'] = this.rate;
    data['imagePath'] = this.imagePath;
    data['brandId'] = this.brandId;
    data['brandName'] = this.brandName;
    return data;
  }
}

export interface IProductDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  rate?: number;
  imagePath?: string | undefined;
  brandId?: string;
  brandName?: string;
}

export class SearchProductsRequest
  extends PaginationFilter
  implements ISearchProductsRequest
{
  brandId?: string | undefined;
  minimumRate?: number | undefined;
  maximumRate?: number | undefined;

  constructor(data?: ISearchProductsRequest) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.brandId = _data['brandId'];
      this.minimumRate = _data['minimumRate'];
      this.maximumRate = _data['maximumRate'];
    }
  }

  static override fromJS(data: any): SearchProductsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new SearchProductsRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['brandId'] = this.brandId;
    data['minimumRate'] = this.minimumRate;
    data['maximumRate'] = this.maximumRate;
    super.toJSON(data);
    return data;
  }
}

export interface ISearchProductsRequest extends IPaginationFilter {
  brandId?: string | undefined;
  minimumRate?: number | undefined;
  maximumRate?: number | undefined;
}

export class ProductDetailsDto implements IProductDetailsDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  rate?: number;
  imagePath?: string | undefined;
  brand?: BrandDto;

  constructor(data?: IProductDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.rate = _data['rate'];
      this.imagePath = _data['imagePath'];
      this.brand = _data['brand']
        ? BrandDto.fromJS(_data['brand'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ProductDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProductDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['rate'] = this.rate;
    data['imagePath'] = this.imagePath;
    data['brand'] = this.brand ? this.brand.toJSON() : <any>undefined;
    return data;
  }
}

export interface IProductDetailsDto {
  id?: string;
  name?: string;
  description?: string | undefined;
  rate?: number;
  imagePath?: string | undefined;
  brand?: BrandDto;
}

export class CreateProductRequest implements ICreateProductRequest {
  name!: string;
  description?: string | undefined;
  rate?: number;
  brandId!: string;
  image?: FileUploadRequest | undefined;

  constructor(data?: ICreateProductRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.description = _data['description'];
      this.rate = _data['rate'];
      this.brandId = _data['brandId'];
      this.image = _data['image']
        ? FileUploadRequest.fromJS(_data['image'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CreateProductRequest {
    data = typeof data === 'object' ? data : {};
    let result = new CreateProductRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['description'] = this.description;
    data['rate'] = this.rate;
    data['brandId'] = this.brandId;
    data['image'] = this.image ? this.image.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICreateProductRequest {
  name: string;
  description?: string | undefined;
  rate?: number;
  brandId: string;
  image?: FileUploadRequest | undefined;
}

export class UpdateProductRequest implements IUpdateProductRequest {
  id?: string;
  name!: string;
  description?: string | undefined;
  rate?: number;
  brandId!: string;
  deleteCurrentImage?: boolean;
  image?: FileUploadRequest | undefined;

  constructor(data?: IUpdateProductRequest) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.description = _data['description'];
      this.rate = _data['rate'];
      this.brandId = _data['brandId'];
      this.deleteCurrentImage = _data['deleteCurrentImage'];
      this.image = _data['image']
        ? FileUploadRequest.fromJS(_data['image'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): UpdateProductRequest {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateProductRequest();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['description'] = this.description;
    data['rate'] = this.rate;
    data['brandId'] = this.brandId;
    data['deleteCurrentImage'] = this.deleteCurrentImage;
    data['image'] = this.image ? this.image.toJSON() : <any>undefined;
    return data;
  }
}

export interface IUpdateProductRequest {
  id?: string;
  name: string;
  description?: string | undefined;
  rate?: number;
  brandId: string;
  deleteCurrentImage?: boolean;
  image?: FileUploadRequest | undefined;
}

export class ExportProductsRequest
  extends BaseFilter
  implements IExportProductsRequest
{
  brandId?: string | undefined;
  minimumRate?: number | undefined;
  maximumRate?: number | undefined;

  constructor(data?: IExportProductsRequest) {
    super(data);
  }

  override init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.brandId = _data['brandId'];
      this.minimumRate = _data['minimumRate'];
      this.maximumRate = _data['maximumRate'];
    }
  }

  static override fromJS(data: any): ExportProductsRequest {
    data = typeof data === 'object' ? data : {};
    let result = new ExportProductsRequest();
    result.init(data);
    return result;
  }

  override toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['brandId'] = this.brandId;
    data['minimumRate'] = this.minimumRate;
    data['maximumRate'] = this.maximumRate;
    super.toJSON(data);
    return data;
  }
}

export interface IExportProductsRequest extends IBaseFilter {
  brandId?: string | undefined;
  minimumRate?: number | undefined;
  maximumRate?: number | undefined;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true;
}
